(() => {
  const STORAGE_KEY = 'ww-page-transition';
  const root = document.documentElement;
  const overlay = document.querySelector('[data-page-transition]');
  const rail = overlay?.querySelector('[data-page-transition-panel]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const gsap = window.gsap;
  let transitioning = false;

  if (!overlay || !rail) {
    root.classList.remove('ww-transition-incoming');
    return;
  }

  const page = () => [...document.querySelectorAll('body > .ww-header, #MainContent, body > .ww-footer')];
  const clearOverlay = () => {
    transitioning = false;
    root.classList.remove('ww-transition-incoming');
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    if (!gsap) return;
    const pageTargets = page();
    gsap.killTweensOf([overlay, rail, ...pageTargets]);
    gsap.set(overlay, { clearProps: 'opacity,visibility,pointerEvents' });
    gsap.set(rail, { clearProps: 'transform' });
    if (pageTargets.length) gsap.set(pageTargets, { clearProps: 'opacity,visibility,transform' });
  };

  let incoming = root.classList.contains('ww-transition-incoming');
  try {
    incoming = incoming || sessionStorage.getItem(STORAGE_KEY) === '1';
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {}

  if (incoming && !reducedMotion && gsap) {
    const incomingPage = page();
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    gsap.set(overlay, { autoAlpha: 1, pointerEvents: 'auto' });
    gsap.set(rail, { scaleX: 1 });
    gsap.set(incomingPage, { autoAlpha: 0, y: 14 });
    gsap.timeline({ defaults: { ease: 'circ.inOut' }, onComplete: clearOverlay })
      .to(incomingPage, { autoAlpha: 1, y: 0, duration: .42, stagger: .035 }, .08)
      .to(rail, { scaleX: 0, duration: .44 }, .2);
  } else {
    clearOverlay();
  }

  const navigate = (href) => {
    if (transitioning) return;
    transitioning = true;
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}

    if (reducedMotion || !gsap) {
      window.location.assign(href);
      return;
    }

    const outgoingPage = page();
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    gsap.set(overlay, { autoAlpha: 1, pointerEvents: 'auto' });
    gsap.set(rail, { scaleX: 0 });

    gsap.timeline({ defaults: { ease: 'circ.inOut' } })
      .to(rail, { scaleX: 1, duration: .34 }, 0)
      .to(outgoingPage, { autoAlpha: 0, y: -12, duration: .3, stagger: .025, ease: 'power2.in' }, .08)
      .call(() => window.location.assign(href));
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download') || link.dataset.noPageTransition !== undefined) return;

    const destination = new URL(link.href, window.location.href);
    const current = new URL(window.location.href);
    if (destination.origin !== current.origin) return;
    if (destination.pathname === current.pathname && destination.search === current.search && destination.hash) return;
    if (destination.href === current.href) return;

    event.preventDefault();
    navigate(destination.href);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) clearOverlay();
  });
})();
